@use "styles" as *;

.me-popover {
  position: absolute;
  inset: 0px auto auto 0px;
  z-index: 10400;
  display: flex;
  flex-direction: column;
  background-color: $color-background-contrast;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  max-width: min($me-popover-max-width, calc(100vw - 2 * $main-padding - $scrollbar-width));

  @include media-breakpoint-only(xs) {
    width: 100%;
  }

  &--animated {
    transition:
      opacity $transition-timing,
      visibility $transition-timing;
  }

  &:not(&--active) {
    opacity: 0;
    visibility: hidden;
  }

  &__header {
    display: flex;
    align-items: center;
    background-color: $color-primary;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    color: $color-background;
  }

  &__title {
    margin-right: auto;
    padding: space(0, 5);
    line-height: $line-height-base;
    font-size: $font-size-l;
    font-weight: $font-weight-semi-bold;

    @include lineClamp(1, $line-height-base, $font-size-l);
  }

  &__close-button.me-button {
    padding: space(3);
    border-width: 0;

    &:focus-visible {
      outline: none;
    }

    .me-button__label {
      color: $color-background;

      &:hover {
        color: $color-gray-200;
      }
    }

    i {
      width: 1em;
      line-height: 1;
      vertical-align: middle;
    }
  }

  &__body {
    display: flex;
    align-items: stretch;
    gap: space(5);
    padding: space(5);

    > .me-separator {
      height: auto;
    }
  }

  &__arrow, &__arrow::before {
    position: absolute;
  }

  &__arrow {
    visibility: hidden;

    &::before {
      visibility: visible;
      content: '';
      width: 0;
      height: 0;
    }
  }

  &[data-popper-placement^='top'] > &__arrow {
    bottom: -$me-popover-arrow-size;
    width: 2 * $me-popover-arrow-size;
    height: $me-popover-arrow-size;

    &::before {
      border-left: $me-popover-arrow-size solid transparent;
      border-right: $me-popover-arrow-size solid transparent;
      border-top: $me-popover-arrow-size solid $color-gray-200;
      transform: translateX(-$me-popover-arrow-size);
    }
  }

  &[data-popper-placement^='bottom'] > &__arrow {
    top: -$me-popover-arrow-size;
    width: 2 * $me-popover-arrow-size;
    height: $me-popover-arrow-size;

    &::before {
      border-left: $me-popover-arrow-size solid transparent;
      border-right: $me-popover-arrow-size solid transparent;
      border-bottom: $me-popover-arrow-size solid $color-primary;
      transform: translateX(-$me-popover-arrow-size);
    }
  }

  &[data-popper-placement^='left'] > &__arrow {
    right: -$me-popover-arrow-size;
    width: $me-popover-arrow-size;
    height: 2 * $me-popover-arrow-size;

    &::before {
      border-top: $me-popover-arrow-size solid transparent;
      border-bottom: $me-popover-arrow-size solid transparent;
      border-left: $me-popover-arrow-size solid $color-gray-200;
      transform: translateY(-$me-popover-arrow-size);
    }
  }

  &[data-popper-placement^='right'] > &__arrow {
    left: -$me-popover-arrow-size;
    width: $me-popover-arrow-size;
    height: 2 * $me-popover-arrow-size;

    &::before {
      border-top: $me-popover-arrow-size solid transparent;
      border-bottom: $me-popover-arrow-size solid transparent;
      border-right: $me-popover-arrow-size solid $color-gray-200;
      transform: translateY(-$me-popover-arrow-size);
    }
  }
}
